import {
  ACTIVITIES_TYPE,
  LABS_TYPE,
  QUIZZES_TYPE,
  TEAMS_ENTITY,
  USERS_ENTITY,
  USERS_TYPE,
  VIDEOS_TYPE,
} from 'constants/analytics';
import { getExportType } from 'utils/tableCsvExport';

export type PageExportEntity = typeof USERS_ENTITY.VALUE | typeof TEAMS_ENTITY.VALUE;

export interface PageExportTable {
  view: string;
  entity: PageExportEntity;
  exportType: string;
}

// Fixed view × entity set for the whole-page export. Users/Teams only — never
// Courses — and independent of the current dashboard selection. "Users with
// activity" has a Users table only.
const PAGE_EXPORT_VIEWS: ReadonlyArray<{ view: string; entities: PageExportEntity[] }> = [
  { view: USERS_TYPE.VALUE.toLowerCase(), entities: [USERS_ENTITY.VALUE] },
  { view: ACTIVITIES_TYPE.VALUE.toLowerCase(), entities: [USERS_ENTITY.VALUE, TEAMS_ENTITY.VALUE] },
  { view: VIDEOS_TYPE.VALUE.toLowerCase(), entities: [USERS_ENTITY.VALUE, TEAMS_ENTITY.VALUE] },
  { view: QUIZZES_TYPE.VALUE.toLowerCase(), entities: [USERS_ENTITY.VALUE, TEAMS_ENTITY.VALUE] },
  { view: LABS_TYPE.VALUE.toLowerCase(), entities: [USERS_ENTITY.VALUE, TEAMS_ENTITY.VALUE] },
];

export function getPageExportTableSet(): PageExportTable[] {
  return PAGE_EXPORT_VIEWS.flatMap(({ view, entities }) =>
    entities.reduce<PageExportTable[]>((tables, entity) => {
      const exportType = getExportType(view, entity);
      if (exportType) tables.push({ view, entity, exportType });
      return tables;
    }, [])
  );
}
